import React from "react";
import { Grid, Tooltip, Typography } from "@material-ui/core";

import Button from "../../../../../components/elements/Button";
import PrimaryButton from "../../../../../components/redesign/elements/Button/PrimaryButton";
import { useCampaignDashboardStyles } from "../../CampaignDashboardStylesContext";

const useNewDesign = process.env.REACT_APP_FEATURE_NEW_DESIGN === "true";

type LandingPageViewModeProps = {
  landingPage: string;
  changeMode: () => void;
};

const LandingPageViewMode = ({ landingPage, changeMode }: LandingPageViewModeProps) => {
  const classes = useCampaignDashboardStyles();
  const hasUrl = Boolean(landingPage?.trim());

  return (
    <Grid className={classes.landingPageContainer}>
      {hasUrl ? (
        <Tooltip title={landingPage}>
          <Typography className={classes.landingPageLinkWrap} component="div" variant="body2">
            <a href={landingPage} target="_blank" rel="noopener noreferrer">
              {landingPage}
            </a>
          </Typography>
        </Tooltip>
      ) : (
        <Typography className={classes.landingPageLinkWrap} component="div" variant="body2" color="textSecondary">
          —
        </Typography>
      )}
      {useNewDesign ? (
        <PrimaryButton onClick={changeMode}>Edit</PrimaryButton>
      ) : (
        <Button onClick={changeMode}>Edit</Button>
      )}
    </Grid>
  );
};

export default LandingPageViewMode;
